__turbopack_context__.v({
  "className": "inter_54d847f0-module__08kdNW__className",
});
